import FadeIn from "@/components/brandRefresh/common/FadeInEffect";
import ButtonLink from "@/components/elements/button-link";
export const CheckEligibility = ({ className = "" }) => (
  <FadeIn direction="bottom">
    <div
      className={`flex flex-col lg:flex-row justify-center gap-4 items-center w-full py-5 px-4 mb-4 bg-onmoPurple-200 rounded-lg ${className}`}
    >
      <ButtonLink
        isBrandRefresh
        button={{
          text: "Check my eligibility",
          url: "/credit-card/application",
        }}
        className="py-3 pl-12 pr-12 w-294 md:w-full rounded-xl bg-onmoPrimary text-white "
      />
      <p className="text-center md:text-left text-sm">
        Checking eligibility won’t affect <br /> your credit score
      </p>
    </div>
  </FadeIn>
);

export const RepresentativeText = () => (
  <FadeIn direction="bottom">
    <p className="text-sm text-center md:text-start">
      Representative example: Assumed credit limit £1,200. Interest rate 39.9%
      p.a. (variable). Representative 39.9% APR (variable). Failing to make
      payments on time or going over your credit limit could damage your credit
      score, making it harder to obtain credit in the future.
    </p>
  </FadeIn>
);

export const balanceCarouselData = [
  {
    id: 1,
    src: "/images/balanceCarousel/balanceCard.png",
    alt: "Balance Card",
  },
  {
    id: 2,
    src: "/images/balanceCarousel/directDebit.png",
    alt: "Direct Debit",
  },
  {
    id: 3,
    src: "/images/balanceCarousel/transaction.png",
    alt: "Transactions",
  },
];

export const creditCardData = [
  {
    id: 1,
    img: "/images/newToCredit/Creditcard.png",
    title: `What's a credit card?`,
    desc: "Credit cards are a flexible way to borrow money, enabling you to make transfers and payments now, with the option to repay your credit provider later.",
    href: "help/faq",
  },
  {
    id: 2,
    img: "/images/newToCredit/Bar-chart1.png",
    title: `How credit card interest works?`,
    desc: "If you choose to repay the full amount, you won’t pay interest on anything you’ve spent. But you’ll still pay interest on cash withdrawals. If you pay less than the full amount, you’ll pay interest on everything you owe.",
    href: "help/faq",
  },
  {
    id: 3,
    img: "/images/newToCredit/Coins.png",
    title: `What can I use a credit card for?`,
    desc: "You can use a credit card for many things such as making purchases, unexpected costs, protection on purchases and consolidating balances.",
    href: "help/faq",
  },
  {
    id: 4,
    img: "/images/newToCredit/Bar-chart2.png",
    title: `What is APR?`,
    desc: "APR stands for Annual Percentage Rate, and it's the yearly cost of borrowing money plus any fees associated associated with a credit card.",
    href: "help/faq",
  },
  {
    id: 5,
    img: "/images/newToCredit/Calculator.png",
    title: `What is a credit card balance?`,
    desc: "Your balance is how much you have spent, plus any interest, fees or charges.",
    href: "help/faq",
  },
  {
    id: 6,
    img: "/images/newToCredit/Star.png",
    title: `What is a credit score?`,
    desc: "Your credit score helps lenders decide whether to lend you money, how much to lend you and how much interest to charge. The higher your score, the better.",
    href: "help/faq",
  },
];

export const transactionItems = [
  " Easily view and pay your balance",
  "Set up and manage your direct debit",
  "Keep track of and be notified of all your transactions",
];

export const ContactBox = ({ email }) => (
  <div className="bg-onmoPurple-50 py-6 px-8 md:py-12 md:px-28 flex justify-center gap-6 rounded-xl flex-col md:flex-row">
    <div className="flex flex-col gap-3 md:gap-6 w-full md:w-52">
      <img
        src="/images/icons/home.svg"
        alt="home-icon"
        className="p-1 h-8 w-8"
      />
      <h4 className="text-xl md:text-2xl text-onmoText">Post</h4>
      <ul className="space-y-1 4xl:text-lg">
        <li>ONMO Ltd</li>
        <li>PO Box 18780</li>
        <li>BIRMINGHAM</li>
        <li>B2 2BN</li>
      </ul>
    </div>

    <div className="flex flex-col gap-6 w-full md:w-52">
      <img
        src="/images/icons/headphone.svg"
        alt="headphone-icon"
        className="p-1 h-8 w-8"
      />
      <h4 className="text-xl md:text-2xl text-onmoText">Phone</h4>
      <ul className="space-y-1 4xl:text-lg">
        <li>Mon to Fri 9am to 5pm</li>
        <li>Call us: 0330 333 6000</li>
      </ul>
    </div>

    <div className="flex flex-col gap-6 w-full md:w-52">
      <img
        src="/images/icons/email.svg"
        alt="email-icon"
        className="p-1 h-8 w-8"
      />
      <h4 className="text-xl md:text-2xl text-onmoText">Email</h4>
      <ul className="space-y-1 4xl:text-lg">
        <li>{email}</li>
        <li>
          Send us an email and we&apos;ll get back to you as soon as we can.
        </li>
      </ul>
    </div>
  </div>
);
/* eslint-disable */
export const cookieNoticeMDX = `
      #### What are Cookies?

Cookies and other similar tracking technologies are small text files or code placed on your device (e.g. computer, smartphone or other electronic device) when you use our website or app (the “Service”) or view a message. Cookies allow a website or app to recognise a particular device. 

#### Our use of Cookies

We use cookies and other similar tracking technologies such as web beacons and single-pixel gifs on our Service. These help us recognise you and your device and store some information about your preferences or past actions.

For example, we may monitor how many times you visit our Service, which pages you go to, traffic data, location data and the originating domain name of your internet service provider. This information helps us to build a profile of our users. Some of this data will be aggregated or statistical, which means that we will not be able to identify you individually.

You can set your browser not to accept cookies and you can find out how to remove cookies from your browser below. However, some of our Service features may not function as a result.

For further information on our use of cookies and other similar tracking technologies, including a

detailed list of your information which we and others may collect through cookies, please see below.

#### What we use cookies for

We use cookies and other similar tracking technologies to:

recognise you whenever you visit our Service (this speeds up your access to our Service as you do not have to log in each time);

obtain information about your preferences and use of our Service;

carry out research and statistical analysis to help improve our content and services and to help us better understand our users’ requirements;

target our marketing and advertising campaigns and those of our affiliates more effectively by providing interest-based advertisements that are personalised to your interests; and make your experience more efficient and enjoyable.

#### Types of cookies

The cookies we place on your device fall into the following categories:

\* **Session cookies**—these allow our Service to link your actions during a particular browser session. These expire each time you close your browser and do not remain on your device afterwards.

\* **Persistent cookies**—these are stored on your device in between browser sessions. These allow your preferences or actions across our Service to be remembered. These will remain on your device until they expire, or you delete them from your cache.

\* **Strictly necessary cookies**—these cookies are essential for you to be able to navigate our Service and use its features. Without these cookies, the Service features and services you have asked for could not be provided.

\* **Performance cookies**—these cookies collect information about how you use our Service, e.g. which pages you go to most often. These cookies do not collect personally identifiable information about you. All information collected by these cookies is aggregated, anonymous, and is only used to improve how our Service works.

\* **Functionality cookies**—these cookies allow our Service to remember the choices you make (such as your user name, language, last action and search preferences) and provide enhanced, more personal features. The information collected by these cookies is anonymous and cannot track your browsing activity on other websites.

\* **Targeting cookies**—also known as advertising cookies, these cookies are used to deliver adverts more relevant to you and your interests. They are also used to limit the number of times you see an advertisement on our Service and help measure the effectiveness of the advertising campaign. They are usually placed by advertising networks with our Service operator’s permission. They remember that you have visited a Service and this information is shared with other organisations such as advertisers.

#### Other technologies we use in email marketing

We also use pixels or web beacons in direct marketing emails that we send to you. These pixels track whether our email was delivered and opened and whether links within the email were clicked. They also allow us to collect information such as your IP address, browser, email client type and other similar details. We use this information to measure the performance of our email campaigns, and for analytics.

You can always opt-out of our marketing communications by using the unsubscribe link located at the bottom of our email communications or you can email us at help@onmo.app

#### Consent to use cookies

We will ask for your permission (consent) to place cookies or other similar tracking technologies on your device, except where these are essential for us to provide you with a service that you have requested.

There is a notice on our home page which describes how we use cookies and requests your consent before we place any non-essential cookies on your device.

#### How to turn off cookies

If you do not want to accept cookies, you can change your browser settings so that cookies are not accepted. If you do this, please be aware that you may lose some of the functionality of our Service. To find out more about cookies, including how to see which cookies have been set and how to manage and delete them, you can visit the third party website: www.allaboutcookies.org

#### Updates to this Cookie Policy

We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons.

The date at the bottom of this Cookie Policy indicates when it was last updated.

#### Contact

If you have questions or concerns regarding our use of cookies or other similar tracking technologies

you can contact us at help@onmo.app

This policy was last updated on 23/09/2022
      `;
/* eslint-enable */
